import React, { useMemo } from "react";
import { files } from "../configs";

const SurveySelectThree = ({
  id,
  setAnswersList,
  answersList,
  isSoleQuestion,
  submit,
}) => {
  const answerIdx = useMemo(
    () => answersList.findIndex((item) => item.questionId === id),
    [answersList, id]
  );

  const answer = useMemo(
    () => (answerIdx >= 0 ? answersList[answerIdx].answers[0].degree : null),
    [answerIdx, answersList]
  );

  const saveAnswer = (degree) => {
    if (answerIdx === -1) {
      let newScreenAnswersList = answersList;
      newScreenAnswersList.push({
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      });

      setAnswersList([...newScreenAnswersList]);
    } else {
      let newScreenAnswersList = answersList;
      newScreenAnswersList[answerIdx] = {
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      };

      setAnswersList([...newScreenAnswersList]);
    }
  };

  return (
    <div className="emoji-rate">
      <input
        id={"rate-bad-" + id}
        type="radio"
        name={"rate-" + id}
        value={1}
        onChange={() => {
          saveAnswer(1);
          if (isSoleQuestion) {
            submit();
          }
        }}
        checked={answer === 1 ? true : false}
      />
      <label
        id={"label-bad-" + id}
        className={answer === 1 ? "active" : null}
        htmlFor={"rate-bad-" + id}
        alt="별로예요"
      >
        <img src={files + "/badEmoji.svg"} alt="별로인 표정" />
        <span>별로예요</span>
      </label>
      <input
        id={"rate-soso-" + id}
        type="radio"
        name={"rate-" + id}
        value={2}
        onChange={() => {
          saveAnswer(2);
          if (isSoleQuestion) {
            submit();
          }
        }}
        checked={answer === 2 ? true : false}
      />
      <label
        id={"label-soso-" + id}
        className={answer === 2 ? "active" : null}
        htmlFor={"rate-soso-" + id}
        alt="보통이에요"
      >
        <img src={files + "/sosoEmoji.svg"} alt="보통인 표정" />
        <span>보통이에요</span>
      </label>
      <input
        id={"rate-good-" + id}
        type="radio"
        name={"rate-" + id}
        value={3}
        onChange={() => {
          saveAnswer(3);
          if (isSoleQuestion) {
            submit();
          }
        }}
        checked={answer === 3 ? true : false}
      />
      <label
        id={"label-good-" + id}
        className={answer === 3 ? "active" : null}
        htmlFor={"rate-good-" + id}
        alt="공감해요"
      >
        <img src={files + "/goodEmoji.svg"} alt="공감하는 표정" />
        <span>공감해요</span>
      </label>
    </div>
  );
};

export default SurveySelectThree;
